import { ComposedModal, ModalBody, ModalFooter, ModalHeader } from "carbon-components-react";
import TestPlayer from "components/TestPlayer/TestPlayer";
import useModalTestPlayer from "hooks/useModalTestPlayer";
import { useState } from "react";

const ModalTestPlayer = (props) => {

    const [newValue, setNewValue] = useState("")

    const {
        modalTestPlayerOpen,
        modalTestPlayerSource,
        setModalTestPlayerSource,
        closeTestPlater,
    } = useModalTestPlayer()

    const close = () => {
        closeTestPlater()
    }

    const onInputChange = (e) => {
        setNewValue(e)
    }

    const updateSource = () => {
        setModalTestPlayerSource(newValue)
    }

    return (
        <ComposedModal
            passiveModal
            preventCloseOnClickOutside={true}
            open={modalTestPlayerOpen}
            onClose={close}
        >
            <ModalHeader
                title={"Test player"}
                buttonOnClick={close} />
            {
                modalTestPlayerOpen && (
                    <ModalBody>
                        <TestPlayer
                            source={modalTestPlayerSource}
                            onInputChange={onInputChange}
                        />
                    </ModalBody>
                )
            }
            <ModalFooter
                primaryButtonText="Update source"
                onRequestClose={close}
                secondaryButtonText="Close"
                onRequestSubmit={updateSource}
                primaryButtonDisabled={newValue === modalTestPlayerSource}
            />
        </ComposedModal>
    )
}

export default ModalTestPlayer